import { render, staticRenderFns } from "./OpenResource.vue?vue&type=template&id=d311ebf0&scoped=true"
import script from "./OpenResource.vue?vue&type=script&lang=js"
export * from "./OpenResource.vue?vue&type=script&lang=js"
import style0 from "./OpenResource.vue?vue&type=style&index=0&id=d311ebf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d311ebf0",
  null
  
)

export default component.exports